import React from 'react';
import CustomHead from '../components/common/head/Head';
import { apiUrl, baseUrl } from '../config/apiConfig';
import axios from 'axios';
import { metaSiteTitle } from '../config/defaultMetaConfig';
import CustomImage from '../components/common/image/CustomImage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faFeather, faLocationArrow, faMapMarkerAlt, faPhoneAlt, faUserAlt } from '@fortawesome/free-solid-svg-icons';
import SectionTitle from '../components/common/section/SectionTitle';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

const ContactPage = ({ siteSetting }) => {
	// console.log("siteSetting", siteSetting);

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm({
		mode: 'onChange',
	});
	const alert = toast;

	const handleContactSubmit = (formData, e) => {
		let bodyFormData = new FormData();
		bodyFormData.append('email', formData.email ? formData.email : '');
		bodyFormData.append('name', formData.name ? formData.name : '');
		bodyFormData.append('message', formData.message ? formData.message : '');

		axios({
			method: 'post',
			url: apiUrl + '/api/postContact',
			data: bodyFormData,
			headers: { 'Content-Type': 'multipart/form-data' },
		})
			.then((response) => {
				alert.success('Your message recived');
				// console.log("response", response);
				e.target.reset();
			})
			.catch((error) => {
				// console.log(error);
			});
	};

	return (
		<>
			<CustomHead title={'Contact Us | ' + (siteSetting && siteSetting.title ? siteSetting.title : metaSiteTitle)} />
			<div className="page-area contact-page-area mh-80v">
				<div className="hero-area position-relative">
					<div className="hero-blush-2 position-absolute top-50 start-0 translate-middle h-90 zi-1"></div>
					<div className="hero-curved-bg position-absolute start-0 top-0 h-100 w-100 zi-2">
						<CustomImage src={baseUrl + '/images/curved-bg.png'} layout="fill" objectFit="cover" objectPosition="bottom" />
					</div>
					<div className="container position-relative zi-3">
						<div className="row gx-25 ">
							<div className="col-lg-6">
								<div className="hero-content py-5">
									<h1 className="hero-title text-gradient text-gradient-blue-light-blue  fs-64 lh-88 mb-4">Contact Us</h1>
									<div className="hero-description fs-32 lh-50 pe-5">If you have an idea, we would love to hear about it.</div>
								</div>
							</div>

							<div className="col-lg-6 text-end d-xs-none">
								<div className="hero-image position-relative h-100">
									<CustomImage src={baseUrl + '/images/contact-us.svg'} layout="fill" objectFit="contain" />
								</div>
							</div>
						</div>
					</div>
				</div>

				{siteSetting && (
					<div className="contact-info-form-area">
						<div className="container">
							<div className="row position-relative justify-content-center zi-3 mb-5">
								<div className="col-lg-9">
									<SectionTitle
										title="How Can We Assist?"
										subTitle="For any questions and queries regarding our services & offers, feel free to drop us a message! We will get back to you ASAP."
										subTitlePosition="bottom"
									/>
								</div>
							</div>
							<div className="row">
								<div className="col-lg-5">
									<div className="contact-info-list">
										{siteSetting.address && (
											<div className="contact-info-box d-flex">
												<div className="icon me-3 bg-gradient-blue-light-blue">
													<FontAwesomeIcon icon={faMapMarkerAlt} />
												</div>
												<div className="text">
													<h4 className="title mb-2 fs-28 lh-36">Address</h4>
													<p className="fs-24 lh-30 mb-0">{siteSetting.address}</p>
												</div>
											</div>
										)}

										{siteSetting.address && (
											<div className="contact-info-box d-flex align-items-center">
												<div className="icon me-3 bg-gradient-blue-light-blue">
													<FontAwesomeIcon icon={faEnvelope} />
												</div>
												<div className="text">
													<h4 className="title mb-2 fs-28 lh-36">Email</h4>
													<p className="fs-24 lh-30 mb-0">
														<a href={`mailto:${siteSetting.email}`}>{siteSetting.email}</a>
													</p>
												</div>
											</div>
										)}

										{siteSetting.address && (
											<div className="contact-info-box d-flex align-items-center">
												<div className="icon me-3 bg-gradient-blue-light-blue">
													<FontAwesomeIcon icon={faPhoneAlt} />
												</div>
												<div className="text">
													<h4 className="title mb-2 fs-28 lh-36">Contact No</h4>
													<p className="fs-24 lh-30 mb-0">
														<a href={`tel:${siteSetting.phone_number}`}>{siteSetting.phone_number}</a>
													</p>
												</div>
											</div>
										)}
									</div>
								</div>
								<div className="col-lg-7">
									<div className="homepage-contact-us-area-wrapper position-relative bg-gradient-blue-light-blue radius-32 overflow-hidden p-4">
										<form onSubmit={handleSubmit(handleContactSubmit)}>
											<div className="homepage-contact-us__form">
												<div className="form-group d-flex">
													<label htmlFor="message">
														<FontAwesomeIcon icon={faFeather} />
													</label>
													<textarea
														name="message"
														id="message"
														cols="30"
														rows="4"
														placeholder="Your Mesage"
														{...register('message', {
															required: 'Message Required',
														})}
													></textarea>
												</div>
												{errors.message && errors.message.message && (
													<span className="error-message" style={{ color: 'red', fontWeight: 'bold' }}>
														{errors.message.message}
													</span>
												)}

												<div className="form-group d-flex">
													<label htmlFor="name">
														<FontAwesomeIcon icon={faUserAlt} />
													</label>
													<input
														name="name"
														id="name"
														type="text"
														placeholder="Enter your name"
														{...register('name', {
															required: 'Name Required',
														})}
													/>
												</div>

												{errors.name && errors.name.message && (
													<span className="error-message" style={{ color: 'red', fontWeight: 'bold' }}>
														{errors.name.message}
													</span>
												)}

												<div className="row">
													<div className="col-lg-8">
														<div className="form-group d-flex mb-3 mb-lg-0">
															<label htmlFor="email">
																<FontAwesomeIcon icon={faEnvelope} />
															</label>
															<input
																name="email"
																id="email"
																type="email"
																placeholder="Enter your email"
																{...register('email', {
																	required: 'Email Required',
																})}
															/>
														</div>
													</div>

													<div className="col-lg-4">
														<button
															type="submit"
															className="btn-submit d-block w-100 fs-18 lh-32 btn-gradient btn-gradient-blue-light-blue reverse position-relative hover overflow-hidden text-white px-4 py-3 radius-12"
														>
															<span className="icon me-3">
																<FontAwesomeIcon icon={faLocationArrow} />
															</span>
															<span className="text">Send</span>
														</button>
													</div>
													{errors.email && errors.email.message && (
														<span className="error-message" style={{ color: 'red', fontWeight: 'bold' }}>
															{errors.email.message}
														</span>
													)}
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				)}

				{/* <ContactUsArea siteSetting={siteSetting} /> */}
			</div>
		</>
	);
};

export async function getServerSideProps() {
	try {
		const siteSetting = await axios
			.get(apiUrl + '/api/siteSetting')
			.then((response) => {
				return response.data.data;
			})
			.catch((error) => {
				return null;
			});

		return {
			props: {
				siteSetting: siteSetting,
				loaded: true,
			},
		};
	} catch (error) {
		return {
			props: {
				siteSetting: null,
				loaded: true,
			},
		};
	}
}

export default ContactPage;
